import {computed, onBeforeUnmount, watch} from "vue";
import useLanderHelper from "./landerHelper";
import {useStore} from "vuex";
import {useRoute} from "vue-router";

export default function useLanderTracker(autoTrack) {
    const store = useStore();
    const route = useRoute();
    const getters = store.getters;
    const {serverLog} = useLanderHelper();

    const visitCount = {};

    const step = computed(() => {
        return parseInt(route.params.step || '1');
    });

    const incrementVisitCount = () => {
        let key = "step_" + step.value;
        if (visitCount.hasOwnProperty(key)) {
            visitCount[key]++;
        } else {
            visitCount[key] = 1;
        }
    }

    const logLanderVisit = () => {
        serverLog({
            action: 'splandervisit', //TODO: Make action dynamic per product
            gift_card_code: getters.gift ? getters.gift.code : '',
            ab_test: getters.abTest
        });
    }

    const logStepVisit = () => {
        serverLog({
            action: 'lander_action',
            gift_card_code: getters.gift ? getters.gift.code : '',
            user_action: `Viewed Step ${step.value}`,
            revisited: visitCount["step_" + step.value] - 1,
        });
    }

    const fireStep2Pixel = () => {
        if (window.SMO) {
            SMO.event('page2');
        }
        if (getters.pixels.sp_step_two_pixel && !getters.isEmailLander) {
            let F = new Function(getters.pixels.sp_step_two_pixel);
            return (F());
        }
    }

    const fireImpressionPixel = () => {
        if (getters.pixels.impression && !getters.isEmailLander) {
            $('head').append(getters.pixels.impression);
        }
    }

    const fireConvPixels = async (frameUrl) => {
        // smOptimize
        if (window.SMO) {
            SMO.event('signup');
        }

        frameUrl.searchParams.set('autht', getters.landerToken);

        (new URLSearchParams(location.search)).forEach((v, k) => {
            if (!frameUrl.searchParams.has(k)) {
                frameUrl.searchParams.set(k, v);
            }
        });
        const iframe = document.createElement("iframe");
        iframe.src = frameUrl.toString();
        iframe.setAttribute("height", 0);
        iframe.setAttribute("width", 0);
        iframe.setAttribute("style", 'display: none; visibility: hidden;');

        document.body.appendChild(iframe);
    };

    let unwatchStep = null;
    const whenReady = () => {
        if (autoTrack) {
            if (!getters.isDomainShifted) {
                logLanderVisit();
                fireImpressionPixel();
            }

            unwatchStep = watch(step, () => {
                if(getters.userSubscribed) {
                    unwatchStep();
                    return;
                }
                incrementVisitCount();
                logStepVisit();
                if (step.value == 2) {
                    fireStep2Pixel();
                }
            }, {immediate: true});
        }
    }

    const unwatchReady = watch(() => getters.landerReady, (ready) => {
        if(ready) {
            whenReady();
            if(unwatchReady) {
                unwatchReady();
            }
        }
    }, {immediate: true});

    onBeforeUnmount(() => {
        if(unwatchStep) {
            unwatchStep();
        }
    })
    return {fireConvPixels};
}
